import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#464646",
      stroke: "#464646",
      "stroke-width": ".5",
      d: "M9.88 6.25a.62.62 0 0 0-.2-.456L4.205.43A.64.64 0 0 0 3.75.25a.62.62 0 0 0-.629.629c0 .173.07.332.18.45L8.332 6.25 3.3 11.172a.64.64 0 0 0-.18.449c0 .36.277.629.63.629a.62.62 0 0 0 .455-.187L9.68 6.706a.63.63 0 0 0 .2-.456Z"
    }, null, -1)
  ])))
}
export default { render: render }